import { Calendar } from "@phosphor-icons/react";
import moment from "moment";
import React, { useEffect } from "react";
import { DATE_FORMATE, STANDARD_DATE_FORMAT } from "../../constant";
import { translatePhrase } from "../../utils/functions";
import Styles from "./DateInput.module.css";
import DateRangePicker from "./DateRangePicker";
import HideComponentWrapper from "../HideComponentWrapper/HideComponentWrapper";
import MaskInput from "../InputField/MaskInput";
import Popover from "../Popover/Popover";
import Button from "../Button/Button";
import { IDateSelectButtonProps } from "../../models/IDateInputProps";

const DateSelectButton: React.FC<IDateSelectButtonProps> = (props: IDateSelectButtonProps) => {
	const { format = DATE_FORMATE, inputFormat = DATE_FORMATE } = props;
	const dateSelectRef = React.useRef<{ closePopup?: () => void; openPopup?: () => void } | null>(null);
	const [pickerDate, setPickerDate] = React.useState<string>("");
	const [dateInput, setDateInput] = React.useState<string>("");

	useEffect(() => {
		if (props.value) {
			setPickerDate(moment(props.value, inputFormat).format(STANDARD_DATE_FORMAT));
			setDateInput(moment(props.value, inputFormat).format(DATE_FORMATE));
		}
	}, [props.value]);

	const handleDateChange = (_date: string) => {
		setPickerDate(moment(_date).format(STANDARD_DATE_FORMAT));
		setDateInput(moment(_date).format(DATE_FORMATE));
		if (props.disableFooter) {
			handleSubmit(_date);
		}
	};
	const TargetButton = () => <Calendar size={20} className={`icon-color ${Styles.calendar_icon}`} />;

	const handleChangeDateInput = (e: React.ChangeEvent<HTMLInputElement>) => {
		const _date = e.target.value;
		setDateInput(_date);
		if (!_date.includes("_")) {
			setPickerDate(moment(_date, DATE_FORMATE).format(STANDARD_DATE_FORMAT));
		}
	};
	const handleSubmit = (_date?: string) => {
		if (dateSelectRef.current && dateSelectRef.current.closePopup) {
			dateSelectRef.current.closePopup();
		}
		const _formatedDate = moment(_date ?? pickerDate).format(format);
		props.handleSubmit(_formatedDate);
	};
	const handleCancel = () => {
		if (dateSelectRef.current && dateSelectRef.current.closePopup) {
			dateSelectRef.current.closePopup();
		}
		setPickerDate(moment(props.value, inputFormat).format(STANDARD_DATE_FORMAT));
		setDateInput(moment(props.value, inputFormat).format(DATE_FORMATE));
		props.handleCancel?.();
	};
	const handleClickToday = () => {
		setPickerDate(moment().format(STANDARD_DATE_FORMAT));
		setDateInput(moment().format(DATE_FORMATE));
	};

	return (
		<Popover
			ref={dateSelectRef}
			parentClass={`${Styles.popup_container} ${Styles.date_input_popover} p-0`}
			position="bottom"
			target={props.target ?? <TargetButton />}
			iconContainerClass="d-flex px-2"
		>
			<HideComponentWrapper hidden={props.disableHeader}>
				<div className={Styles.custom_date_field}>
					<MaskInput
						id={"start-date"}
						name={"start-date"}
						value={dateInput}
						onChange={handleChangeDateInput}
						formClass={"m-0 w-100"}
						required={false}
						formSubmitted={false}
						label={""}
						placeholder={DATE_FORMATE}
						mask="_"
						format="##/##/####"
						className={"m-0"}
						sectionType="none"
					/>
					<Button onClick={handleClickToday} label={translatePhrase("today")} variant={"secondary"} />
				</div>
			</HideComponentWrapper>
			<DateRangePicker
				onDateChange={handleDateChange}
				format="YYYY-MM-DD"
				isDoubleCalender={false}
				isRangePicker={false}
				value={{ startDate: pickerDate, endDate: "" }}
				className="p-3"
				inputFormat={STANDARD_DATE_FORMAT}
				defaultMonth={props.defaultMonth}
				size={props.size}
			/>
			<HideComponentWrapper hidden={props.disableFooter}>
				<hr className="m-0" />
				<div className={Styles.date_input_footer}>
					<Button className="w-100" label="Cancel" onClick={handleCancel} variant="secondary" />
					<Button className="w-100" label="Apply" onClick={handleSubmit} variant="primary" />
				</div>
			</HideComponentWrapper>
		</Popover>
	);
};

DateSelectButton.displayName = "DateSelectButton";
export default DateSelectButton;
